import createProjectPin from 'App/components/Map/mapPins/ProjectPin';
import createAccountAddressPin from 'App/components/Map/mapPins/AccountAddressPin';
import type { SupportedPinEntity, AccountAddress, ProjectPlanType } from './MapPinTypes';

export const PIN_TYPE = {
	PROJECT_PLAN: 'PROJECT_PLAN',
	ACCOUNT_ADDRESS: 'ACCOUNT_ADDRESS'
};

export const createPin = (entity: SupportedPinEntity, type: string) => {
	switch (type) {
		case PIN_TYPE.PROJECT_PLAN:
			return createProjectPin(entity as ProjectPlanType);
		case PIN_TYPE.ACCOUNT_ADDRESS:
			return createAccountAddressPin(entity as AccountAddress);
		default:
			return createProjectPin(entity as ProjectPlanType);
	}
};
